<template>
    <div class="board-container">
        <table class="board-list">
    		<thead class="d-none d-lg-table-header">
                <tr>
                    <th style="width:10%;" class="board-list__txt">번호</th>
                    <th style="width:72%;" class="board-list__txt">제목</th>
                    <th style="width:18%;" class="board-list__txt">작성일</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(notification, index) in fixed" :key="index">
                    <td align="center" class="board-list__txt board-list__txt--first">
                        <v-icon>{{ mdiAlertCircleOutline }}</v-icon>
                    </td>
                    <td align="center" class="board-list__tit" @click="$router.push(`${$route.path}/${notification._id}`)">
                        <div class="ellip">{{ notification.subject }}</div>
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ notification.createdAt.toDate() }}
                    </td>
                </tr>
                <tr v-for="(notification, index) in notifications" :key="index">
                    <td align="center" class="board-list__txt board-list__txt--first">
                        {{ (page - 1) * limit + index + 1 }}
                    </td>
                    <td align="center" class="board-list__tit" @click="$router.push(`${$route.path}/${notification._id}`)">
                        <div class="ellip">{{ notification.subject }}</div>
                    </td>
                    <td align="center" class="board-list__txt">
                        {{ notification.createdAt.toDate() }}
                    </td>
                </tr>
    		</tbody>
    	</table>
        <!-- <div role="table" class="board-table table--primary board-table--notice">
            <div role="rowgroup">
                <div role="row">
                    <div role="columnheader" class="num">번호</div>
                    <div role="columnheader" class="tit">제목</div>
                    <div role="columnheader" class="date">작성일</div>
                </div>
            </div>
            <div role="rowgroup">
                <div v-for="(notification, index) in fixed" :key="index" role="row">
                    <div role="cell" class="num">
                        <v-icon>{{ mdiAlertCircleOutline }}</v-icon>
                    </div>
                    <div role="cell" class="tit font-weight-bold">
                        <a @click="$router.push(`${$route.path}/${notification._id}`)">{{ notification.subject }}</a>
                    </div>
                    <div role="cell" class="date font-weight-bold">
                        <span class="date">{{ notification.createdAt.toDate() }}</span>
                    </div>
                </div>
            </div>
            <div role="rowgroup">
                <div v-for="(notification, index) in notifications" :key="index" role="row">
                    <div role="cell" class="num">{{ (page - 1) * limit + index + 1 }}</div>
                    <div role="cell" class="tit">
                        <a @click="$router.push(`${$route.path}/${notification._id}`)">{{ notification.subject }}</a>
                    </div>
                    <div role="cell" class="date">
                        <span class="date">{{ notification.createdAt.toDate() }}</span>
                    </div>
                </div>
            </div>
        </div> -->
        <pagination-component v-model="page" :count="pageCount" @input="search"></pagination-component>
    </div>
</template>

<script>
import api from "@/api";
import PaginationComponent from "@/components/client/control/pagination-component.vue";
import { mdiAlertCircleOutline } from "@mdi/js";
export default {
    components: {
        PaginationComponent,
    },
    props: {
        value: { type: String, default: null },
    },
    data() {
        return {
            mdiAlertCircleOutline,

            filter: { isNotice: false, sites: "yfactory" },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 20,

            fixed: [],
            notifications: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search() {
            this.$router.push({
                query: Object.assign({}, this.query, { page: this.page }),
            });

            var { notifications: fixed } = await api.v1.center.notifications.gets({
                headers: {
                    limit: 0,
                },
                params: { isNotice: true, sites: "yfactory" },
            });

            this.fixed = fixed;

            var { summary, notifications } = await api.v1.center.notifications.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.notifications = notifications;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
    },
};
</script>
